import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './templates/EmploymentList.html?raw';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import lang from 'dojo/_base/lang';
// NOTE (JS2TS): dropped dead dojo deps (_base/connect, on). DOM-heavy → dom-construct aliased to any.

const domConstruct: any = domConstructTyped;

class EmploymentList extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    associateID: any = null;
    projectID: any = null;
    item: any = null;
    externalButton: any = null;
    jsonEntitylist: any = null;

    startup(): void {
        domClass.remove(this.reloadBtn, "w3-hide");
        this.loadEmployments();
    }

    loadEmployments(): void {

        //spinners.global().spin(document.getElementById('spinner_box'));
        this.StandbyStart();

        domConstruct.empty(this.tableNode);
        domClass.remove(this.tableNode);

        var url = window.appRoot + "SOV/OrchestraGetMusicanEmployments";

        this.RequestManager.post(
            url,
            {
                associateID: this.item.ref_associate,
                projectID: this.item.ref_ev_project,
            },
            lang.hitch(this, "_onLoadEmploymentsResponse"),
            lang.hitch(this, "_onLoadEmploymentsError"),
            false // sync
        );
    }

    _onLoadEmploymentsResponse(response: any): void {
        var jsonEntitylist = JSON.parse(response);
        console.log("_onLoadEmploymentsResponse", jsonEntitylist);

        this.jsonEntitylist = jsonEntitylist;

        var bShowFunction = this.item.LvlEmployments >= 110;

        // Tabelle erzeugen....
        var table = domConstruct.create("table");
        domConstruct.place(table, this.tableNode);
        //domClass.add(table, "w3-border");
        domStyle.set(table, "margin-bottom", "0");

        var thead = domConstruct.create("thead");
        domConstruct.place(thead, table);

        var row = domConstruct.create("tr");
        domConstruct.place(row, thead);

        // Spalten mit den Überschriften
        var col = domConstruct.create("td");
        domConstruct.place(col, row);
        domAttr.set(col, "innerHTML", "Termine");

        col = domConstruct.create("td");
        domConstruct.place(col, row);
        domAttr.set(col, "innerHTML", "Dienstzeit");

        if (bShowFunction === true) {
            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", "Instrument");
        }

        col = domConstruct.create("td");
        domConstruct.place(col, row);
        domAttr.set(col, "innerHTML", "Eingeteilt");
        domClass.add(col, "w3-right-align");

        var tbody = domConstruct.create("tbody");
        domConstruct.place(tbody, table);

        if (jsonEntitylist.length == 0) {
            var row = domConstruct.create("tr");
            domConstruct.place(row, thead);

            // Spalten mit den Überschriften
            var col = domConstruct.create("td");
            domAttr.set(col, "colspan", bShowFunction === true ? "4" : "3");
            domConstruct.place(col, row);
            domClass.add(col, "w3-center");
            domAttr.set(col, "innerHTML", "<i>keine Einträge</i>");
        }

        for (var i = 0; i < jsonEntitylist.length; i++) {
            var entity = jsonEntitylist[i];

            row = domConstruct.create("tr");
            domConstruct.place(row, tbody);

            // Spalten mit den Inhalten
            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", entity.ref_ev_booking.gDisp_1);

            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", entity.tmp_daterange_web);

            if (bShowFunction === true) {
                col = domConstruct.create("td");
                domConstruct.place(col, row);
                domAttr.set(col, "innerHTML", entity.c_function_name);
            }

            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", entity.ref_vt_duty_type.code);
            domClass.add(col, "w3-right-align");


        }

        //spinners.global().stop();
        this.StandbyStop();

        if (this.externalButton != null) {
            domClass.add(this.externalButton, "w3-hide");
        }

        this._onClickShow();
    }

    _onLoadEmploymentsError(error: any): void {
        console.log("_onLoadEmploymentsError", error);
        //spinners.global().stop();
        this.StandbyStop();
    }

    _onClickReload(evt: any): void {
        this.loadEmployments();
    }

    _onClickHide(evt: any): void {
        domClass.add(this.tableNode, "w3-hide");

        //domClass.remove(this.hideBtn, "w3-button");
        //domClass.add(this.hideBtn, "w3-disabled");

        //domClass.add(this.showBtn, "w3-button");
        //domClass.remove(this.showBtn, "w3-disabled");
    }

    _onClickShow(evt?: any): void {
        //domClass.remove(this.showBtn, "w3-hide");
        //domClass.remove(this.hideBtn, "w3-hide");
        domClass.remove(this.reloadBtn, "w3-hide");

        if (this.jsonEntitylist == null) {
            this._onClickReload(evt);
        } else {
            domClass.remove(this.tableNode, "w3-hide");
        }

        //domClass.remove(this.showBtn, "w3-button");
        //domClass.add(this.showBtn, "w3-disabled");

        //domClass.add(this.hideBtn, "w3-button");
        //domClass.remove(this.hideBtn, "w3-disabled");
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

}
EmploymentList.prototype.declaredClass = 'WidgetCollection.SOV.legacy.Main.EmploymentList';

export default mdsWidget(EmploymentList);
